import React from 'react';
import Chart from '../../charts/Chart';
import { useIntl } from 'react-intl';

export default function TimeseriesChart({ selectedJob, series = [], loading, error }) {
  const intl = useIntl()

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold">
          {intl.formatMessage({ id: "dga.timeseries.title", defaultMessage: "Timeseries Data" })}
        </h3>
        <p className="text-sm text-gray-600 mt-1">
          {selectedJob?.id
            ? intl.formatMessage(
              { id: "dga.timeseries.monitoring", defaultMessage: "Monitoring data for {name}" },
              { name: selectedJob.region_code }
            )
            : intl.formatMessage({ id: "dga.timeseries.selectJob", defaultMessage: "Select a job to show it's data" })}
        </p>
      </div>
      <div className="p-6">
        {error && (
          <div className="text-sm text-red-600 mb-3">
            {intl.formatMessage(
              { id: "dga.timeseries.failed", defaultMessage: "Failed to load data: {msg}" },
              { msg: String(error.message || error) }
            )}
          </div>
        )}

        {(!loading && !error && (!series || series.every(s => !s.data || s.data.length === 0))) ? (
          <div className="h-[400px] flex items-center justify-center bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
            <div className="text-center space-y-2">
              <div className="text-sm text-gray-600">
                {intl.formatMessage({ id: "dga.timeseries.noData", defaultMessage: "No data available for the selected range." })}
              </div>
            </div>
          </div>
        ) : (
          selectedJob?.id &&
          <div className='min-w-full lg:min-w-[50%] 2xl:min-w-[33%] pt-4'>
            <Chart
              intl={intl}
              graphs={series}
              name={selectedJob.region_code}
              maximized={true}
              chartId={"dga_charts_" + selectedJob.id}
              isForecast={true}
              loading={loading}
            />
          </div>
        )}
      </div>
    </div>
  )
}
